import { useContext, useEffect, useRef, useState } from "react";
import {
  DeleteDevice,
  GetDeviceOwnerShipStatus,
  RemoveDeviceOwnerShipStatus,
  UpdateDevice,
  UpdateDeviceOwnerShip,
} from "../api/api";
import ErrorToast from "./toasts/ErrorToast";
import SuccessToast from "./toasts/SuccessToast";
import { Context } from "../context/Context";
import SetDeviceTimeModal from "./modals/SetDeviceTimeModal";
import SetDeviceInputsModal from "./modals/SetDeviceInputsModal";
import EventScenarioModal from "./modals/EventScenarioModal";
import EventScenarioLearnCodeModal from "./modals/EventScenarioLearnCodeModal";
import NotificationSettingsModal from "./modals/NotificationSettingsModal";
import Devices from "../constants/Devices";
import SetBridgeDeviceModal from "./modals/SetBridgeDeviceModal";
import { MqttContext } from "../context/MQTTContext";
import "simplebar-react/dist/simplebar.min.css";
import DefineChartModal from "./modals/DefineChartModal";
import WarningAlert from "./sweeAlerts/WarningAlert";
import AddDeviceModal from "./modals/AddDeviceModal";
import ApiKeyModal from "./modals/ApiKeyModal";

const DevicesList = () => {
  const {
    setIsLoading,
    setChangeNameOptions,
    handleChangeNameModal,
    handleDefineChartModal,
    update,
    setUpdate,
    setChartInfo,
    handleChartModal,
    handleApiKeyModal,
    handleAddDeviceModal,
    authUser,
    devices,
    setDevices,
  } = useContext(Context);

  const { clients } = useContext(MqttContext);

  const [deviceTime, setDeviceTime] = useState();
  const [deviceInputsModal, setDeviceInputsModal] = useState(null);
  const [eventScenarioModal, setEventScenarioModal] = useState(null);
  const [eventScenarioLearnCodeModal, setEventScenarioLearnCodeModal] =
    useState(null);
  const [setBridgeDeviceModal, setSetBridgeDeviceModal] = useState(null);
  const [notificationSettingsModal, setNotificationSettingsModal] =
    useState(null);
  // const [devices, setDevices] = useState([]);
  const [devicesLockStatus, setDevicesLockStatus] = useState({});
  const [deviceShouldBeChange, setDeviceShouldBeChange] = useState(null);
  const [deviceShouldChangeBridgeDevice, setDeviceShouldChangeBridgeDevice] =
    useState(null);
  const [type, setType] = useState(null);
  const [scenarioNumberForEventScenario, setScenarioNumberForEventScenario] =
    useState(null);
  // const [update, setUpdate] = useState(false);
  const [chartSettingProperties, setChartSettingsProperties] = useState({
    device: null,
    chartCount: 0,
    hasCycle: false,
    hasStatus: false,
    hasDataAddress: false,
    hasSlaveAddress: false,
    hasFunctionCode: false,
    hasQuantity: false,
    hasSubmitKey: false,
    hasSendOnChange: false,
  });

  const eventScenarioLearnCodeModalRef = useRef(null);

  const timeData = useRef(null);
  const inputStates = useRef(null);
  const messageListenerRef = useRef(null);

  const clientSetTime = useRef();

  // useEffect(() => {
  //   setIsLoading(true);
  //   DevicesListApi()
  //     .then(({ data }) => {
  //       setDevices(data.devices);
  //       setIsLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  useEffect(() => {
    if (devices.length) {
      devices.forEach((device) => {
        if (device.is_bus == 0 && clients[device.id]) {
          const messageListener = (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            if (
              device.internet_token.slice(-2) === endOfTwoCharToken &&
              message[2] == 7
            ) {
              setDevicesLockStatus((prev) => ({
                ...prev,
                [device.id]: message[3],
              }));
            }
          };
          clients[device.id].on("message", messageListener);

          const decimalArray = [3, 2];
          const asciiArray = decimalArray.map((num) =>
            String.fromCharCode(num),
          );
          clients[device.id].publish(
            device.serial + "/sys",
            device.internet_token + asciiArray.join(""),
          );
        }
      });

      return () => {
        devices.forEach((device) => {
          if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
            clients[device.bridge_device.id].removeAllListeners("message");
          } else if (
            device.id &&
            device.username &&
            device.password &&
            clients[device.id]
          ) {
            clients[device.id].removeAllListeners("message");
          }
        });
      };
    }
  }, [devices]);

  const handleDeviceTimeModal = (device) => {
    if (!clients[device.id]) return;

    const messageListener = (topic, message) => {
      const endOfTwoCharToken =
        String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
      if (
        device.internet_token.slice(-2) === endOfTwoCharToken &&
        message[2] == 9
      ) {
        timeData.current = message.slice(3);
        const modal = new window.bootstrap.Modal(deviceTime.current);
        clients[device.id].removeAllListeners("message");
        modal.show();
      }
    };
    clients[device.id].on("message", messageListener);
    let buffer = new ArrayBuffer(7);
    let asciiCode = new Uint8Array(buffer);
    asciiCode[0] = 9;
    asciiCode[1] = 60;
    asciiCode[2] = 60;
    asciiCode[3] = 60;
    asciiCode[4] = 60;
    asciiCode[5] = 60;
    asciiCode[6] = 60;
    let message = device.internet_token;
    let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
    clients[device.id].publish(device.serial + "/sys", combinedMessage);
    setDeviceShouldBeChange(device);
  };

  const handleDeviceInputsModal = (device) => {
    setDeviceShouldBeChange(device);
    setType("input");
    const modal = new window.bootstrap.Modal(deviceInputsModal.current);
    modal.show();
  };

  const handleDeleteDevice = (device_id) => {
    WarningAlert(
      "هشدار",
      "با حذف دستگاه، تمام تجهیزات و سناریوهای مرتبط با دستگاه حذف خواهند شد. از حذف دستگاه اطمینان دارید؟", 'بله'
    ).then(function (result) {
      if (result.value) {
        setIsLoading(true);
        DeleteDevice({
          device_id,
        })
          .then(({ data }) => {
            setDevices((devices) =>
              devices.filter((device) => device.id !== device_id),
            );
            return SuccessToast(data.message);
          })
          .catch(({ response }) => {
            return ErrorToast(response.data.message);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    });
  };

  const handleLockDevice = (device, status) => {
    if (status !== 0 && status !== 1 && clients[device.id]) return;

    let buffer = new ArrayBuffer(2);
    let asciiCode = new Uint8Array(buffer);
    asciiCode[0] = 4;
    asciiCode[1] = status == 1 ? 0 : 1;
    let message = device.internet_token;
    let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
    clients[device.id].publish(device.serial + "/sys", combinedMessage);

    setTimeout(() => {
      const messageListener = (topic, message) => {
        const endOfTwoCharToken =
          String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
        if (
          device.internet_token.slice(-2) === endOfTwoCharToken &&
          message[2] == 7
        ) {
          setDevicesLockStatus((prev) => ({
            ...prev,
            [device.id]: message[3],
          }));
        }
      };
      clients[device.id].on("message", messageListener);

      const decimalArray = [3, 2];
      const asciiArray = decimalArray.map((num) => String.fromCharCode(num));
      clients[device.id].publish(
        device.serial + "/sys",
        device.internet_token + asciiArray.join(""),
      );
    }, 200);
  };

  const handleEventScenario = (device) => {
    setScenarioNumberForEventScenario(1);
    setDeviceShouldBeChange(device);
    const modal = new window.bootstrap.Modal(eventScenarioModal.current);
    modal.show();
    modal.hide();
  };

  const handleBridgeDeviceModal = (device) => {
    setDeviceShouldChangeBridgeDevice(device);
    const modal = new window.bootstrap.Modal(setBridgeDeviceModal.current);
    modal.show();
  };

  const handleEventScenarioLearnCodeModal = (device) => {
    if (device.is_bus == 1 && clients[device.bridge_device.id]) {
      const client = clients[device.bridge_device.id];

      if (messageListenerRef.current) {
        client.removeListener("message", messageListenerRef.current);
        messageListenerRef.current = null;
      }

      const messageListener = (topic, message) => {
        const endOfTwoCharToken =
          String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
        const deviceSerial =
          String.fromCharCode(message[3]) +
          String.fromCharCode(message[4]) +
          String.fromCharCode(message[5]) +
          String.fromCharCode(message[6]) +
          String.fromCharCode(message[7]) +
          String.fromCharCode(message[8]);

        if (
          device.bridge_device.internet_token.slice(-2) === endOfTwoCharToken &&
          device.serial === deviceSerial &&
          message[10] == 8 &&
          message[2] == 14
        ) {
          SuccessToast("به شماره رویداد " + message[11] + " اختصاص یافت");
          eventScenarioLearnCodeModalRef.current.click();

          client.removeListener("message", messageListener);
          messageListenerRef.current = null;
        }
      };

      messageListenerRef.current = messageListener;
      client.on("message", messageListener);

      let buffer = new ArrayBuffer(11);
      let asciiCode = new Uint8Array(buffer);
      asciiCode[0] = 14;
      asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
      asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
      asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
      asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
      asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
      asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
      asciiCode[7] = device.type + 50;
      asciiCode[8] = 7;
      asciiCode[9] = scenarioNumberForEventScenario;
      asciiCode[10] = 0;

      let message = device.bridge_device.internet_token;
      let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

      client.publish(device.bridge_device.serial + "/sys", combinedMessage);
    } else if (clients[device.id]) {
      const client = clients[device.id];

      if (messageListenerRef.current) {
        client.removeListener("message", messageListenerRef.current);
        messageListenerRef.current = null;
      }

      const messageListener = (topic, message) => {
        const endOfTwoCharToken =
          String.fromCharCode(message[0]) + String.fromCharCode(message[1]);

        if (
          device.internet_token.slice(-2) === endOfTwoCharToken &&
          message[2] == 8
        ) {
          SuccessToast("به شماره رویداد " + message[3] + " اختصاص یافت");
          eventScenarioLearnCodeModalRef.current.click();

          client.removeListener("message", messageListener);
          messageListenerRef.current = null;
        }
      };

      messageListenerRef.current = messageListener;
      client.on("message", messageListener);

      let buffer = new ArrayBuffer(3);
      let asciiCode = new Uint8Array(buffer);
      asciiCode[0] = 7;
      asciiCode[1] = scenarioNumberForEventScenario;
      asciiCode[2] = 0;

      let message = device.internet_token;
      let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

      client.publish(device.serial + "/sys", combinedMessage);
    }

    const modal = new window.bootstrap.Modal(
      eventScenarioLearnCodeModal.current,
    );
    modal.show();
  };

  const handleShowNotificationSettingsModal = (device) => {
    setDeviceShouldBeChange(device);
    setUpdate((prev) => !prev);
    const modal = new window.bootstrap.Modal(notificationSettingsModal.current);
    modal.show();
  };

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleSumbitName = (device) => {
    const onSubmitFunc = ({ device, name }) => {
      UpdateDevice({
        device_id: device.id,
        device_name: name,
      }).then(({ data }) => {
        // SuccessToast("نام دستگاه با موفقیت ثبت شد");
        setDevices((prevDevices) =>
          prevDevices.map((dev) =>
            dev.id == device.id ? { ...dev, name: name } : dev,
          ),
        );
      });
    };

    const newOptions = {
      name: device.name,
      onSubmit: (newName) => {
        onSubmitFunc({ device, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };

  // const handleChartSettings = (device) => {
  //   GetDeviceOwnerShipStatus({
  //     device_id: device.id,
  //   }).then(({ data }) => {
  //     if (data.status) {
  //       if (device.type == 16) {
  //         setChartSettingsProperties((prev) => ({
  //           ...prev,
  //           device,
  //           hasCycle: true,
  //           hasStatus: true,
  //           hasDataAddress: true,
  //           hasSlaveAddress: true,
  //           hasFunctionCode: true,
  //           hasQuantity: true,
  //           hasSubmitKey: false,
  //           hasSendOnChange: true,
  //         }));
  //       } else {
  //         setChartSettingsProperties((prev) => ({
  //           ...prev,
  //           device,
  //           hasCycle: true,
  //           hasStatus: true,
  //           hasDataAddress: false,
  //           hasSlaveAddress: false,
  //           hasFunctionCode: false,
  //           hasQuantity: false,
  //           hasSubmitKey: false,
  //           hasSendOnChange: true,
  //         }));
  //       }
  //       setUpdate((prev) => !prev);
  //       handleDefineChartModal();
  //     } else {
  //       handleConnectToWallet(device, () => {
  //         if (device.type == 16) {
  //         setChartSettingsProperties((prev) => ({
  //           ...prev,
  //           device,
  //           hasCycle: true,
  //           hasStatus: true,
  //           hasDataAddress: true,
  //           hasSlaveAddress: true,
  //           hasFunctionCode: true,
  //           hasQuantity: true,
  //           hasSubmitKey: false,
  //           hasSendOnChange: true,
  //         }));
  //       } else {
  //         setChartSettingsProperties((prev) => ({
  //           ...prev,
  //           device,
  //           hasCycle: true,
  //           hasStatus: true,
  //           hasDataAddress: false,
  //           hasSlaveAddress: false,
  //           hasFunctionCode: false,
  //           hasQuantity: false,
  //           hasSubmitKey: false,
  //           hasSendOnChange: true,
  //         }));
  //       }
  //       setUpdate((prev) => !prev);
  //       handleDefineChartModal();
  //       })
  //     }
  //   });
  // };

  const handleChartSettings = (device) => {
    GetDeviceOwnerShipStatus({
      device_id: device.id,
    }).then(({ data }) => {
      if (data.status) {
        const props = {
          device,
          hasCycle: true,
          hasStatus: true,
          hasSendOnChange: true,
        };
        if (device.type == 16) {
          props.hasDataAddress = true;
          props.hasSlaveAddress = true;
          props.hasFunctionCode = true;
          props.hasQuantity = true;
        }
        setChartSettingsProperties(props);
        setUpdate((prev) => !prev);
        handleDefineChartModal();
      } else {
        handleConnectToWallet(
          device,
          () => {
            const props = {
              device,
              hasCycle: true,
              hasStatus: true,
              hasSendOnChange: true,
            };
            if (device.type == 16) {
              props.hasDataAddress = true;
              props.hasSlaveAddress = true;
              props.hasFunctionCode = true;
              props.hasQuantity = true;
            }
            setChartSettingsProperties(props);
            setUpdate((prev) => !prev);
            handleDefineChartModal();
          },
          "در صورت تایید، هزینه‌های مربوط به ثبت داده از حساب کیف پول شما کسر خواهد شد",
        );
      }
    });
  };

  const handleShowChart = (device) => {
    if ([1, 2, 7, 8, 10, 11, 12, 13, 14, 15].includes(Number(device.type))) {
      setChartInfo({
        type: 2,
        device_id: device.id,
        device_type: device.type,
        chart_num: 1,
        first_index: 1,
        count: 28,
        coefficients: [],
        // names: { [button.digit]: button.name },
      });
    } else if ([4, 9].includes(Number(device.type))) {
      setChartInfo({
        type: 2,
        device_id: device.id,
        device_type: device.type,
        chart_num: 1,
        first_index: 1,
        count: 10,
        coefficients: [],
        // names: { [button.digit]: button.name },
      });
    } else if ([5].includes(Number(device.type))) {
      setChartInfo({
        type: 2,
        device_id: device.id,
        device_type: device.type,
        chart_num: 1,
        first_index: 1,
        count: 16,
        coefficients: [],
        // names: { [button.digit]: button.name },
      });
    } else if ([3].includes(Number(device.type))) {
      setChartInfo({
        type: 2,
        device_id: device.id,
        device_type: device.type,
        chart_num: 1,
        first_index: 1,
        count: 20,
        coefficients: [],
        // names: { [button.digit]: button.name },
      });
    }
    handleChartModal();
  };

  const handleManageWallet = (device) => {
    setIsLoading(true);
    GetDeviceOwnerShipStatus({
      device_id: device.id,
    })
      .then(({ data }) => {
        if (data.status && authUser.phone_number == data.phone_number) {
          // remove wallet connection
          handleRemoveWallet(device, () => {});
        } else if (data.status) {
          // connect to own wallet
          handleConnectToAnotherUser(
            device,
            "دستگاه به کیف پول دیگری متصل است.",
          );
        } else {
          // set new wallet
          handleConnectToWallet(
            device,
            () => {},
            "در صورت تایید، هزینه‌های مربوط به ثبت داده از حساب کیف پول شما کسر خواهد شد",
          );
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleConnectToWallet = (device, callback = null, message = "") => {
    WarningAlert("", message, "تایید", "انصراف").then(function (result) {
      if (result.value) {
        UpdateDeviceOwnerShip({ device_id: device.id }).then((res) => {
          if (res.data.status) {
            SuccessToast(res.data.message);
            if (callback && typeof callback === "function") {
              callback();
            }
          } else {
            ErrorToast(res.data.message);
          }
        });
      }
    });
  };

  const handleConnectToAnotherUser = (device, message) => {
    WarningAlert("", message, "تایید", "انصراف", false).then(function (result) {
      if (result.value) {
      }
    });
  };

  const handleRemoveWallet = (device, callback = null) => {
    WarningAlert(
      "",
      "دستگاه به کیف پول شما متصل می باشد. در صورت تمایل به قطع اتصال بر روی دکمه 'لغو اتصال' کلیک کنید",
      "لغو اتصال",
      "انصراف",
    ).then(function (result) {
      if (result.value) {
        RemoveDeviceOwnerShipStatus({ device_id: device.id }).then((res) => {
          if (res.data.status) {
            SuccessToast(res.data.message);
            if (callback && typeof callback === "function") {
              callback();
            }
          } else {
            ErrorToast(res.data.message);
          }
        });
      }
    });
  };

  const handleShowApiKeyModal = (device) => {
    setDeviceShouldBeChange(device);
    setUpdate((prev) => !prev);
    handleApiKeyModal();
  };

  const renderDevicesList = () => {
    if (!devices.length) return;
    return devices.map((device) => {
      let d = Devices.find((i) => i.type == device.type);
      if (!d) {
        return;
      }
      return (
        <div
          className="col-12 col-md-6 col-lg-4 device-list-item p-0 m-0 p-1"
          key={device.id}
        >
          <div className="card mb-1">
            <div className="card-body">
              <div className="card-title header-elements mb-0 py-3 px-2">
                {authUser.is_admin ? (
                  <div className="btn-group">
                    <button
                      type="button"
                      className="btn btn-icon rounded-pill dropdown-toggle hide-arrow me-2"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bx bx-dots-vertical-rounded"></i>
                    </button>
                    <ul className="dropdown-menu">
                      <li onClick={() => handleSumbitName(device)}>
                        <span className="dropdown-item">تغییر نام</span>
                      </li>
                      {device.type == 10 || device.type == 12 ? (
                        <li onClick={() => handleDeviceInputsModal(device)}>
                          <span className="dropdown-item">تنظیم ورودی</span>
                        </li>
                      ) : null}
                      {device.is_bus == 0 ? (
                        <li
                          onClick={() =>
                            handleLockDevice(
                              device,
                              devicesLockStatus?.[device.id],
                            )
                          }
                        >
                          <span className="dropdown-item">
                            {devicesLockStatus?.[device.id] ? "بازکردن" : "قفل"}
                          </span>
                        </li>
                      ) : null}
                      {device.is_bus == 1 ? (
                        <li onClick={() => handleBridgeDeviceModal(device)}>
                          <span className="dropdown-item">درگاه اتصال</span>
                        </li>
                      ) : null}
                      {device.type == 3 ? (
                        <li onClick={() => handleEventScenario(device)}>
                          <span className="dropdown-item">
                            تنظیم سناریو رویداد
                          </span>
                        </li>
                      ) : null}
                      {(device.type == 3 ||
                        device.type == 10 ||
                        device.type == 12) &&
                      device.is_bus == 0 ? (
                        <li
                          onClick={() =>
                            handleShowNotificationSettingsModal(device)
                          }
                        >
                          <span className="dropdown-item">اعلان</span>
                        </li>
                      ) : null}
                      {device.is_bus == 0 ? (
                        <li onClick={() => handleDeviceTimeModal(device)}>
                          <span className="dropdown-item">بروزرسانی زمان</span>
                        </li>
                      ) : null}
                      {device.is_bus == 0 &&
                      ((device.fw_version >= 12 && device.fw_version <= 14) ||
                        device.fw_version >= 17) &&
                      device.type != 16 ? (
                        <li onClick={() => handleShowChart(device)}>
                          <a className="dropdown-item">نمایش نمودار</a>
                        </li>
                      ) : null}
                      {device.is_bus == 0 &&
                      ((device.fw_version >= 12 && device.fw_version <= 14) ||
                        device.fw_version >= 17) ? (
                        <li
                          onClick={() => {
                            handleChartSettings(device);
                          }}
                        >
                          <span className="dropdown-item">تنظیمات نمودار</span>
                        </li>
                      ) : null}
                      {device.is_bus == 0 &&
                      ((device.fw_version >= 12 && device.fw_version <= 14) ||
                        device.fw_version >= 17) ? (
                        <li onClick={() => handleManageWallet(device)}>
                          <span className="dropdown-item">مدیریت کیف پول</span>
                        </li>
                      ) : null}

                      {device.is_bus == 0 ? (
                        <li onClick={() => handleShowApiKeyModal(device)}>
                          <span className="dropdown-item">کلید دسترسی API</span>
                        </li>
                      ) : null}

                      <li onClick={() => handleDeleteDevice(device.id)}>
                        <span className="dropdown-item">حذف</span>
                      </li>
                    </ul>
                  </div>
                ) : null}

                {device.is_bus == 0 &&
                  (devicesLockStatus[device.id] != undefined ? (
                    <img
                      src="/assets/img/app-icons/ic_cloud_done_black_24dp.png"
                      className="me-2"
                      style={{ width: "19px" }}
                    />
                  ) : (
                    <img
                      src="/assets/img/app-icons/ic_offline_black_24dp.png"
                      className="me-2"
                      style={{ width: "19px" }}
                    />
                  ))}
                {device.is_bus == 0 ? (
                  devicesLockStatus?.[device.id] ? (
                    <i className="bx bxs-lock text-success"></i>
                  ) : (
                    <i className="bx bxs-lock-open me-2 text-danger"></i>
                  )
                ) : null}

                {device.is_bus == 1 ? (
                  <img
                    src="/assets/img/app-icons/rD.png"
                    className="me-2"
                    alt=""
                    style={{ width: "19px" }}
                  />
                ) : null}
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <p className="m-0 me-2">{device.name}</p>
                  <p className="m-0 me-2">{d.prefix + "-" + device.serial}</p>
                  {device.is_bus == 1 ? (
                    <div className="text-center">
                      <span>Gateway: {device.bridge_device_serial}</span>
                    </div>
                  ) : null}
                </div>
                <div className="ms-auto">
                  {device.type == 1 && device.is_bus == 1 ? (
                    <img src="/assets/img/app-icons/0E.png" alt="" />
                  ) : device.type == 1 && device.is_bus == 0 ? (
                    <img src="/assets/img/app-icons/UQ.png" alt="" />
                  ) : null}
                  {device.type == 2 ? (
                    <img src="/assets/img/app-icons/7c1.png" alt="" />
                  ) : null}
                  {device.type == 3 ? (
                    <img src="/assets/img/app-icons/je.png" alt="" />
                  ) : null}
                  {device.type == 4 ? (
                    <img src="/assets/img/app-icons/gD.png" alt="" />
                  ) : null}
                  {device.type == 5 ? (
                    <img src="/assets/img/app-icons/t05.png" alt="" />
                  ) : null}
                  {device.type == 7 ? (
                    <img src="/assets/img/app-icons/wp.png" alt="" />
                  ) : null}
                  {device.type == 8 ? (
                    <img src="/assets/img/app-icons/aw.png" alt="" />
                  ) : null}
                  {device.type == 9 ? (
                    <img src="/assets/img/app-icons/gD.png" alt="" />
                  ) : null}
                  {device.type == 10 ? (
                    <img src="/assets/img/app-icons/Kw.png" alt="" />
                  ) : null}
                  {device.type == 11 ? (
                    <img src="/assets/img/app-icons/89.png" alt="" />
                  ) : null}
                  {device.type == 12 ? (
                    <img src="/assets/img/app-icons/Kw.png" alt="" />
                  ) : null}
                  {device.type == 13 ? (
                    <img src="/assets/img/app-icons/Uk.png" alt="" />
                  ) : null}
                  {device.type == 14 ? (
                    <img src="/assets/img/app-icons/UR.png" alt="" />
                  ) : null}
                  {device.type == 15 ? (
                    <img src="/assets/img/app-icons/UO.png" alt="" />
                  ) : null}
                  {device.type == 16 ? (
                    <img src="/assets/img/app-icons/5.png" alt="" />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };
  return (
    <>
      <div className="card-body scrollbar mt-3">
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
        <div className="row device-list mx-3 mt-2">{renderDevicesList()}</div>
        {/* </SimpleBar> */}
      </div>
      <SetDeviceTimeModal
        setDeviceTime={setDeviceTime}
        deviceTime={deviceTime}
        time={timeData}
        device={deviceShouldBeChange}
      />
      <SetDeviceInputsModal
        setDeviceInputsModal={setDeviceInputsModal}
        inputStates={inputStates}
        device={deviceShouldBeChange}
        type={type}
      />
      <EventScenarioModal
        setEventScenarioModal={setEventScenarioModal}
        device={deviceShouldBeChange}
        scenarioNum={scenarioNumberForEventScenario}
        setScenarioNum={setScenarioNumberForEventScenario}
        handleEventScenarioLearnCodeModal={handleEventScenarioLearnCodeModal}
      />
      <EventScenarioLearnCodeModal
        setEventScenarioLearnCodeModal={setEventScenarioLearnCodeModal}
        eventScenarioLearnCodeModalRef={eventScenarioLearnCodeModalRef}
      />
      <NotificationSettingsModal
        setNotificationSettingsModal={setNotificationSettingsModal}
        device={deviceShouldBeChange}
        update={update}
      />
      <SetBridgeDeviceModal
        setSetBridgeDeviceModal={setSetBridgeDeviceModal}
        device={deviceShouldChangeBridgeDevice}
      />
      <DefineChartModal
        device={chartSettingProperties.device}
        chartCount={chartSettingProperties.chartCount}
        hasCycle={chartSettingProperties.hasCycle}
        hasStatus={chartSettingProperties.hasStatus}
        hasDataAddress={chartSettingProperties.hasDataAddress}
        hasSlaveAddress={chartSettingProperties.hasSlaveAddress}
        hasFunctionCode={chartSettingProperties.hasFunctionCode}
        hasQuantity={chartSettingProperties.hasQuantity}
        hasSubmitKey={chartSettingProperties.hasSubmitKey}
        hasSendOnChange={chartSettingProperties.hasSendOnChange}
      />
      <AddDeviceModal />
      <ApiKeyModal device={deviceShouldBeChange} update={update} />
    </>
  );
};

export default DevicesList;
